var map = {
	"./news-card/news-card.riot": 47,
	"./sponsor-card/sponsor-card.riot": 48,
	"./sponsor-image/sponsor-image.riot": 49,
	"./team-message/team-message.riot": 50,
	"./video-content/video-content.riot": 51
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46;